import React from 'react'
import styled from 'styled-components'
import { vanguard_icon } from '../../assets'
import { colors } from '../../colors'

const NewsPaperFeedCard = ({tags, news}) => {
  return (
    <Container>
        <InnerContainer>
        <ImageContainer src={news} alt='newspaper_icon' />
        <Title>
            <h4>
                {news?.newspaperName}
            </h4>

            <h5>{news?.newspaperDescription}</h5>

            {tags 
        
                ?

                <Tags>
                   
                    <span>Product</span>
                    <span>Tool</span>
                    
                </Tags>

                : null
                
            }
        </Title>

        
        </InnerContainer>
        
    </Container>
  )
}

export const Container = styled.section`
    width: 100%;
    /* border: 1px solid red; */
    border-bottom: 2px solid #D0D5DD;
    border-radius: 4px;
    outline: 1px solid #D0D5DD;
    margin-top: 10px;
    cursor: pointer;

`

export const InnerContainer = styled.div`
    display: flex;
    align-items: center;
    /* align-self: flex-start; */
    padding: 20px 20px;

    & > p{
        align-self: flex-start;
    }
`;

export const Tags = styled.div`
    display: flex;
    margin-top: 10px;

    & :first-child{
        color: #026AA2;
        background-color: #F0F9FF;
        border-radius: 16px;
    }

    & :last-child{
        border-radius: 16px;
        color: #C11574;
        background-color: #FDF2FA;
        margin-left: 10px;
    }
     
    & span{
        font-size: 14px;
        padding: 2px 10px;
    }
`

export const Title = styled.div`

    padding-left: 20px;
    display: flex;
    flex-direction: column;
    align-self: flex-start;
    
    & h4{
        align-self: flex-start;
        font-weight: 600;
    }

    & h5{
        align-self: flex-start;
        font-size: 12px;
        color: ${colors.faint_text};
    }
`

export const ImageContainer = styled.img`
    border-radius: 2px;
    height: 60px;
    width: 60px;
    /* border: 1px solid red; */

    @media screen and (max-width: 600px){
            height: 50px;
        }
    
`

export {NewsPaperFeedCard}